module.exports = __webpack_public_path__ + "img/A3F6_new.4d941b63.jpg";